<script>
const tips = {
  insertDiscountTips: '核算费用时以有效时间内,失效日期最近的版本优先,如果该版本下未设置折扣,将无法计算出费用;如有无用的版本请删除或停用!',
  passDiscountSettingTips: '设置通折将覆盖原来的折扣数据,请谨慎操作!',
  discountBatchSettingTips: '批量设置折扣将覆盖原来的折扣数据,请谨慎操作!',
}
export default {
  tips,
}
</script>



// WEBPACK FOOTER //
// src/common/message.vue